const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M6.25 8.75A.75.75 0 0 1 7 8h4.25V3.75a.75.75 0 0 1 1.5 0V8H17a.75.75 0 0 1 0 1.5h-4.25v4.25a.75.75 0 0 1-1.5 0V9.5H7a.75.75 0 0 1-.75-.75m-3 10.5A.75.75 0 0 1 4 18.5h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75"/></svg>';
export {
  a as w
};
